/* eslint-disable */
import { post } from '../../http/restservice'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import { messageModalState } from '../../store/Feedback'
import { usePaymentProcessingTimer } from '../../hooks/useProcessingTimer'
import { Progress } from '../../Components/ui/progress'
import PaymentStatusModal from '../../Components/modals/OneTimePayment'
import { toCurrency } from '../../utils/CurrencyUtil'

const POLL_INTERVAL = 10000 // 10 sec

const MFBasketBankPayment = () => {
  const payData = useMemo(
    () => JSON.parse(localStorage.getItem('basketPaymentStatusData')) || {},
    [],
  )

  const location = useLocation()

  let responseString = location?.state?.response ? location?.state?.response : payData?.response

  // const responseString =
  //   '<!DOCTYPE html>\r\n \r\n\r\n\r\n\r\n<html lang="en">\r\n\r\n<head>\r\n  <base href="https://www.billdesk.com/" />\r\n  <meta charset="utf-8" />\r\n  <meta http-equiv="cache-control" content="no-cache" />\r\n  <meta name="viewport" content="width=device-width, initial-scale=1">\r\n  <meta name="robots" content="noindex, nofollow">\r\n\r\n  <link rel="stylesheet" href="/error/assets/style.css" />\r\n  \r\n  <title>Payment Processing - BillDesk</title>\r\n<script language=JavaScript>\r\n\r\n\r\nvar message="Function Disabled!";\r\n\r\n\r\nfunction clickIE4(){\r\nif (event.button==2){\r\nreturn false;\r\n}\r\n}\r\n\r\nfunction clickNS4(e){\r\nif (document.layers||document.getElementById&&!document.all){\r\nif (e.which==2||e.which==3){\r\nreturn false;\r\n}\r\n}\r\n}\r\n\r\nif (document.layers){\r\ndocument.captureEvents(Event.MOUSEDOWN);\r\ndocument.onmousedown=clickNS4;\r\n}\r\nelse if (document.all&&!document.getElementById){\r\ndocument.onmousedown=clickIE4;\r\n}\r\n\r\ndocument.oncontextmenu=new Function("return false")\r\n\r\n</script>\r\n</head>\r\n<body>\r\n  <div class="main-container">\r\n      <img src="/error/assets/images/processing.svg" alt="error" class="mx-auto"/>\r\n      <h1>Processing your payment securely <div class="loader"></div></h1>\r\n      <h4>This usually takes a few seconds but may take up to <b>10 seconds</b> during peak times.</h4>\r\n\r\n      <div class="chips mx-auto"><img src="/error/assets/images/bulb.svg" alt="bulb" /> To keep things smooth</div>\r\n      <ul>\r\n          <li><b>Avoid refreshing or going back,</b> your payment is already on its way.</li>\r\n          <li><b>Don\'t click \'Submit\' more than once.,</b> this prevents duplicate charges.</li>\r\n      </ul>\r\n  </div>\r\n\r\n\r\n\r\n\r\n<form name="Bankfrm" method="post" action=\'https://netbanking.hdfcbank.com/netbanking/merchant\'>\r\n \r\n\t\t\t  \r\n              <input type = "hidden" name = "ClientCode" value="25060542633">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = "hidden" name = "MerchantCode" value="BILLDKINDI24">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = "hidden" name = "TxnAmount" value="200000.00">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = "hidden" name = "TxnScAmount" value="0.00">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = "hidden" name = "MerchantRefNo" value="YHDF2581275364">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = "hidden" name = "SuccessStaticFlag" value="N">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = "hidden" name = "FailureStaticFlag" value="N">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = "hidden" name = "Date" value="05/06/2025 13:38:15">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = "hidden" name = "ClientAccNum" value="50100171783165">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = "hidden" name = "DynamicUrl" value="https://www.billdesk.com/pgidsk/PGIProcessResponse/HDF">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = "hidden" name = "CheckSum" value="256666545">\r\n\t\t\t\r\n              \r\n\t\t\t  \r\n              <input type = "hidden" name = "TxnCurrency" value="INR">\r\n\t\t\t\r\n              \r\n\t</form>\r\n\r\n<script>\r\ndocument.Bankfrm.submit();\r\n</script>\r\n</body>\r\n</html>\r\n'

  const setMessageModalState = useSetRecoilState(messageModalState)
  const intervalRef = useRef(null)
  const [timeElapsed, setTimeElapsed] = useState(0)
  const { progress, time } = usePaymentProcessingTimer(300) // 2 minutes

  // Modal state management
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [modalData, setModalData] = useState({})
  const [loading, setLoading] = useState(false)

  // const baskets = useRecoilValueLoadable(MFTimeBasedBaskets)

  const openPaymentModal = (data) => {
    setModalData(data)
    setShowPaymentModal(true)
  }

  const closePaymentModal = () => {
    setShowPaymentModal(false)
    setModalData({})
    setLoading(false)
  }

  const paymentStatus = async (elapsed) => {
    try {
      const response = await post('/mutualfundservice/api/bseStar/mfUpload/paymentStatus', {
        clientCode: payData?.clientCode,
        orderNo: payData?.orderNo,
        isBasketOrder: true,
      })

      if (response.isError) {
        setMessageModalState({
          message: response?.response?.message,
          severity: 'error',
        })
      }

      const status = response?.data
      if (response?.status === 'SUCCESS') {
        if (status?.includes('AWAITING') && elapsed >= 30) {
          openPaymentModal({
            onContinue: '/dashboard/mutual-funds/orders',
            status: 'inprogress',
            paymentData: {
              amount: toCurrency(payData?.amount || 0),
              paymentMode: 'Net Banking',
              date: new Date().toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              }),
            },
          })
          clearInterval(intervalRef.current)
        }

        if (status?.includes('APPROVED')) {
          openPaymentModal({
            onContinue: '/dashboard/mutual-funds/orders',
            status: 'success',
            paymentData: {
              amount: toCurrency(payData?.amount || 0),
              paymentMode: 'Net Banking',
              date: new Date().toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              }),
            },
          })
          clearInterval(intervalRef.current)
        }
      }
    } catch (error) {
      console.log('🚀 ~ paymentStatus ~ error:', error)
    }
  }

  useEffect(() => {
    if (!location?.state) {
      intervalRef.current = setInterval(() => {
        setTimeElapsed((prev) => {
          const updated = prev + 10
          paymentStatus(updated)

          if (updated >= 300) {
            clearInterval(intervalRef.current)
          }

          return updated
        })
      }, POLL_INTERVAL)

      return () => clearInterval(intervalRef.current)
    }
  }, [])

  useEffect(() => {
    if (location?.state) {
      const container = document.getElementById('bankPage')
      setTimeout(() => {
        const form = container?.querySelector('form[name="Bankfrm"]')
        if (form) {
          form.submit()
        }
      }, 3000)

      return () => {
        if (container?.parentNode) {
          container.parentNode.removeChild(container)
        }
      }
    }
  }, [responseString])

  return (
    <>
      <div className='flex justify-center items-center h-screen bg-white'>
        {!location?.state ? (
          <div>
            <div className='ease-in-out md:max-w-2xl m-auto flex flex-col justify-center px-2'>
              <div className='flex flex-col gap-y-12'>
                {/* <div>
                <img src={`${env.SVGS}/payment.gif`} alt='Payment Gif' className='rounded-xl' />
              </div> */}
                <div className='flex flex-col gap-y-5'>
                  <div className='flex flex-col gap-y-3'>
                    <h1 className='text-2xl font-medium text-center'>Processing Your Payment</h1>
                    <p className='text-center text-secondary-700 bg-secondary-50 font-medium rounded-full text-xs leading-3 py-2'>
                      Please wait on the screen for confirmation after payment
                    </p>

                    <Progress value={progress} className='h-2 bg-primary-100' />
                  </div>

                  <p className='text-center text-sm font-medium text-black-400 '>
                    Please wait while we process your payment. This may take 1-2 minutes.
                    <br />
                    <span className='animate-pulse'>Do not close or go back.</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            id='bankPage'
            dangerouslySetInnerHTML={{ __html: responseString }}
            className='fixed top-0 left-0 right-0 bottom-0 z-[1000] bg-white h-screen w-screen'
          />
        )}
      </div>

      <PaymentStatusModal
        isOpen={showPaymentModal}
        onClose={closePaymentModal}
        onContinue={modalData.onContinue}
        onRetry={modalData.onRetry}
        status={modalData.status}
        loading={loading}
        paymentData={modalData.paymentData}
      />
    </>
  )
}

export default MFBasketBankPayment
